import { Grid } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import InputForm from '../../InputT';
import SearchModal from '../../SearchModal';
import RadioBox from '../../Radiox';
import ParamsPicklist from '../../../Types/ParamsPicklist';

let searchLienGroupe: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre: 'RUBRIQ', valfiltre: 'LIENAMONTESAVAL', Choix: 22 }
let searchSecteurEco: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre: 'RUBRIQ', valfiltre: 'SECTEURECONOMIQUE', Choix: 22 }
let searchQualiteActeur: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre: 'RUBRIQ', valfiltre: 'QUALITEACTEUR', Choix: 22 }

const Tab4 = (props: { form?: any }) => {

  return (
    <div className='tabItem'>
      <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
        <Grid item xs={12} md={6} className='border-left'>
          <SearchModal
            form={props.form}
            notRequired
            width={7}
            Titre='Recherche Lien Groupe Amont/Aval'
            label='Lien Groupe Amont/Aval'
            name='LienGroupeAmontAval'
            Parametre={searchLienGroupe}
            title="Permet d'identifier si le client a des liens de dépendance amont (détention d'au moins 10% des droits de vote) ou aval (entreprise comprise dans le périmètre de consolidation)."
          />
          <SearchModal
            form={props.form}
            notRequired
            width={7}
            Titre='Recherche Secteur Economique / Institutionnel'
            label='Secteur Economique / Institutionnel'
            name='SecteurEconomique'
            Parametre={searchSecteurEco}
            title="Permet de catégoriser le client selon son secteur institutionnel (agents économiques financiers ou non financiers comme les administrations publiques et sociétés)."
          />
        </Grid>
        <Grid item xs={12} md={6} className='border-left'>
          <SearchModal
            form={props.form}
            notRequired
            width={7}
            Titre='Recherche Qualité Acteur Lié'
            label='Qualité Acteur Lié'
            name='QualiteActeurLie'
            Parametre={searchQualiteActeur}
            title="Permet d'identifier spécifiquement si le client est un actionnaire, un partenaire, un directeur, un dirigeant ou un membre du personnel de l'institution."
          />
          {/* <RadioBox
            width={7}
            label='Statut Créance Douteuse'
            name='StatutCreanceDouteuse'
            Value1='O'
            Value2='N'
            LibValue1='OUI'
            libVlue2='NON'
            // title="Permet de suivre l'historique ou l'existence de créances douteuses (effet de contagion, impayés de plus de 45 jours) impactant le profil de risque global du client."
          /> */}
        </Grid>
      </Grid>
    </div>
  );
}

export default Tab4;
